const common = {
	id: 'ID',
	administration: 'Verwaltung',
	created: 'angelegt | erstellt',
	capitalizeCreated: '@.capitalize:common.created',
	edited: 'bearbeitet',
	edit: 'Bearbeiten',
	active: 'aktive',
	activate: { name: 'aktivieren', icon: 'fas fa-toggle-on' },
	deactivate: { name: 'deaktivieren', icon: 'fas fa-toggle-off' },
	reviewed: 'Geprüft',
	createdAt: 'Erstellt am',
	createdBy: 'Erstellt von',
	updated: 'aktualisiert',
	authorized: 'freigeschaltete',
	capitalizeUpdated: '@.capitalize:common.updated',
	updatedAt: 'Aktualisiert am',
	startedAt: 'Gültig von',
	endedAt: 'Gültig bis',
	readOn: 'Gelesen am',
	onlyActive: 'nur aktive',
	onlyActiveHint:
		'„Nur aktive" zeigt ausschließlich aktuell aktive Rollen. „Alle" zeigt zusätzlich Vormieter und nicht mehr aktive Rollenpersonen.',
	description: 'Beschreibung',
	information: 'Informationen',
	attachFile: 'Dateien anhängen',
	properties: 'Liegenschaften',
	page: 'Seite',
	toAll: 'an alle',
	from: 'von',
	to: 'auf',
	until: 'bis',
	file: 'Datei | Dateien',
	selected: 'ausgewählt',
	number: 'Nr.',
	emails: 'E-Mails',
	send: 'Senden',
	general: 'Allgemein',
	appointment: 'Termin',
	user: 'Benutzer',
	management: 'Management',
	usernameEmail: 'Benutzername / E-Mail',
	emailAdress: 'E-Mail Adresse',
	name: 'Name',
	color: 'Farbe',
	salutation: 'Anrede',
	academicTitle: 'Titel',
	firstName: 'Vorname',
	lastName: 'Nachname',
	password: 'Passwort',
	password_confirmation: 'Passwort Bestätigung',
	selectDate: 'Datum auswählen',
	comment: 'Kommentar | Kommentare',
	Login: 'Anmeldung',
	showAll: 'Alle Anzeigen',
	search: 'Suche',
	data: 'Daten',
	no_data_available: 'Keine Daten vorhanden.',
	loaded: 'geladen',
	date: 'Datum',
	type: 'Typ',
	size: 'Größe',
	origin: 'Herkunft',
	publicLabel: 'Öffentlich',
	group: 'Gruppe',
	grouped: 'Gruppiert',
	toOccur: 'Erledigung bis',
	list: 'Liste',
	status: 'Status',
	subject: 'Betreff',
	price: 'Preis',
	subject_type: 'Betreff Art',
	characters: 'Zeichen',
	time: 'Uhrzeit',
	loadMore: 'Weiter {displayName} laden',
	readMore: 'weiterlesen',
	hide: 'ausblenden',
	show: 'anzeigen',
	accept: 'Akzeptieren',
	accepted: 'Angenommen',
	pending: 'Ausstehend',
	all: 'Alle',
	mine: 'Meine',
	portalOwn: 'Nur Portal',
	openReports: 'Offene',
	closedReports: 'Erledigte',
	dateFrom: 'Datum von',
	dateTo: 'Datum bis',
	urgent: 'Dringend',
	finalize: 'Abschließen',
	release: 'Freigeben',
	deadline: 'Frist',
	confirmed: 'Geprüft',
	rejected: 'Beanstandet',
	reviewer: 'Prüfer',
	access: 'Zugriff',
	yes: 'Ja',
	no: 'Nein',
	not: 'nicht',
	result: 'Ergebnis',
	storage: 'Speicherplatz',
	add_documents: 'Dokumente hinzufügen',
	items_per_page: 'Elemente pro Seite:',
	recipient: 'Empfänger',
	noContent: 'Kein Inhalt',
	reply: 'Antwort',
	links: 'Verknüpfungen',
	remarks: 'Bemerkung',
	back: 'Zurück',
	next: 'Weiter',
	copy: 'Kopieren',
	critical: 'Kritisch',
	insert: 'Einfügen',
	actions: 'Aktionen',
	templates: 'Vorlage | Vorlagen',
	sender: 'Absender',
	placeholder: 'Platzhalter',
	sendCredentials: 'Zugangsdaten senden',
	fromPerspectiveOf: 'Aus der Sicht von',
	selectFiles: 'Dateien auswählen',
	toBind: 'Verknüpfen',
	changes: 'Änderungen',
	entry: 'Eintrag | Einträge',
	category: 'Kategorie',
	question: 'Frage',
	scheduled: 'Geplant',
	continue: 'Fortfahren',
	undo: 'Rückgängig',
	discard: 'Verwerfen',
	team: 'Team',
	unlink: 'Entknüpfen',
	upcoming: 'Anstehend',
	selectAll: 'Alle abwählen',
	reset: 'Zurücksetzen',
	dataConfirmation:
		'Ich erkläre, dass die von mir eingegebenen Daten korrekt sind.',
	genericRetry: 'Es ist ein Fehler aufgetreten, versuchen Sie es bitte erneut.',
	example: {
		private: 'z.B. privat',
	},
	open: {
		name: 'Öffnen',
		icon: 'far fa-eye',
	},
	print: {
		name: 'Drucken',
		icon: 'far fa-print',
	},
	approve: {
		name: 'Freigeben',
		icon: 'fas fa-check',
	},
	confirm: {
		name: 'Geprüft',
		icon: 'fa-solid fa-check',
	},
	reject: {
		name: 'Ablehnen | Beanstanden',
		icon: 'fa-solid fa-ban',
	},
	create: {
		name: 'Erstellen',
		icon: 'fas fa-plus',
	},
	save: {
		name: 'Speichern',
		icon: 'fas fa-save',
	},
	saveAndClose: 'Speichern & schließen',
	update: {
		name: 'Aktualisieren | Bearbeiten',
		icon: 'fal fa-edit',
	},
	delete: {
		name: 'Löschen',
		icon: 'fas fa-trash',
	},
	close: {
		name: 'Schließen',
		icon: 'fas fa-close',
	},
	cancel: {
		name: 'Abbrechen',
		icon: 'fas fa-ban',
	},
	add: {
		name: 'Hinzufügen',
		icon: 'fas fa-plus',
	},
	return: {
		name: 'Zurück',
		icon: 'fas fa-step-backward',
	},
	remove: {
		name: 'Entfernen',
		icon: 'fas fa-minus',
	},
	login: {
		name: 'Anmelden',
		icon: 'fal fa-sign-in',
	},
	logout: {
		name: 'Abmelden',
		icon: 'fas fa-sign-out-alt',
	},
	settings: {
		name: 'Einstellungen',
		icon: 'fas fa-user-cog',
	},
	reload: {
		name: 'Aktualisieren',
		icon: 'fas fa-arrows-rotate',
	},
	releaseNote: {
		name: 'Was ist Neu',
		icon: 'fas fa-pen-to-square',
	},
	link: { name: 'Verknüpfung | Verknüpfungen ', icon: 'fas fa-link' },
	noLink: { name: 'Keine Verknüpfung', icon: 'fas fa-link-horizontal-slash' },
	priority: {
		highest: 'Höchste',
		high: 'Hoch',
		medium: 'Mittel',
		low: 'Niedrig',
		lowest: 'Niedrigste',
		none: 'Keine',
	},
	privacy: 'Datenschutz',
	imprint: 'Impressum',
	privacyPolicy: 'Datenschutzerklärung',
	termsOfUse: 'Nutzungsbedingungen',
	tabs: {
		masterData: {
			name: 'Stammdaten',
			icon: 'fa-fw fas fa-info-square',
		},
	},
	tips: {
		passwordOnlyChangeableByTeamMember:
			'Das Passwort kann nach einmaliger Anlage nur noch vom Teammitglied selbst im Menüpunkt Konto bearbeitet werden',
		rolePermissionVisibleForAll:
			'Wenn diese Option aktiviert ist, stehen Personen, die die Personenfunktion <b>{0}</b> haben, entweder allen oder nur den ausgewählten Personenfunktionen zur Verfügung, die eine aktive Personenfunktion an der gleichen Liegenschaft oder Einheit haben. Diese Einstellung greift unabhängig von den eingestellten Zugriffsregelungen.',
		rolePermissionGrantsAccessToAllPersonsOfUnitOrBuilding:
			'Die Personenfunktion <b>{0}</b> hat mit der Freigabe dieser Option einen Zugriff auf die in der <b>{1}</b> befindlichen Personen mit den gewählten aktiven Personenfunktionen',
		rolePermissionGrantsAccessToAllUnitsOfBuilding:
			'Wenn diese Option aktiviert ist und die Personenfunktion ist auf die Liegenschaft geschlüsselt und <b>nicht</b> auf eine Einheit innerhalb der Liegenschaft, stehen alle Einheiten innerhalb der Liegenschaft zur Verfügung!',
		userNameCannotBeChanged:
			'Benutzername / E-Mail kann nach einmaliger Anlage nicht abgeändert werden',
		unitAddressLinkIsRequired:
			'Wenn diese Option aktiviert ist, werden nur Dokumente angezeigt, die der Einheit und der jeweiligen Adresse zugeordnet sind. Diese Einstellung bezieht sich ausschließlich auf Dokumente die der Einheit zugeordnet sind.',
		notesCreateBuildingLinkInfo:
			'Die hinterlegten Liegenschaften und Personenfunktionen gelten auch für die Benachrichtigungen. Ist keine Liegenschaft ausgewählt, sondern nur Personenfunktionen, werden Benachrichtigungen für alle Liegenschaften versendet. Mit der Option "dringend" werden die Einstellungen der Benutzer ignoriert und die Benachrichtigung trotzdem versendet.',
		reviewDocumentsReminderInfo:
			'Hier kann eingestellt werden, wann und ob eine Erinnerungsmail für die Belegprüfung versendet werden soll.',
	},
	viewAll: 'Alle anzeigen',
}

export default common
